import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRecurrence = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_70_24215",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 16,
		height: 16,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15.3979,
			height: 15.3979,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_70_24215)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.69806 14.1148C6.89608 14.1148 6.1449 13.9624 5.44451 13.6577C4.74411 13.3529 4.13461 12.9412 3.616 12.4226C3.09739 11.904 2.68571 11.2945 2.38095 10.5941C2.0762 9.89374 1.92383 9.14255 1.92383 8.34058H3.20699C3.20699 9.59166 3.64273 10.6529 4.51421 11.5244C5.38569 12.3959 6.44698 12.8316 7.69806 12.8316C8.94914 12.8316 10.0104 12.3959 10.8819 11.5244C11.7534 10.6529 12.1891 9.59166 12.1891 8.34058C12.1891 7.08949 11.7534 6.02821 10.8819 5.15673C10.0104 4.28525 8.94914 3.84951 7.69806 3.84951H7.60182L8.59627 4.84396L7.69806 5.77425L5.13173 3.20793L7.69806 0.641602L8.59627 1.57189L7.60182 2.56635H7.69806C8.50004 2.56635 9.25122 2.71872 9.95161 3.02347C10.652 3.32822 11.2615 3.7399 11.7801 4.25852C12.2987 4.77713 12.7104 5.38663 13.0152 6.08702C13.3199 6.78742 13.4723 7.5386 13.4723 8.34058C13.4723 9.14255 13.3199 9.89374 13.0152 10.5941C12.7104 11.2945 12.2987 11.904 11.7801 12.4226C11.2615 12.9412 10.652 13.3529 9.95161 13.6577C9.25122 13.9624 8.50004 14.1148 7.69806 14.1148Z",
			fill: "#1F3171"
		})
	})]
});
export default SvgRecurrence;
